import React from 'react';
import { usePaymentContext } from '../../../contexts/payment/paymentContext';
import ActionButton from '../../../components/buttons/ActionButton';

const ItemCheckoutButton = ({ transaction }) => {
  const { chargeTransaction, isLoading, isError, isSubmitted } = usePaymentContext();
  const isSuccessEmbedded = (isSubmitted && !isLoading && !isError);

  return !isSuccessEmbedded && (
    <ActionButton
      text="Checkout"
      width="full"
      isLoading={isLoading}
      onClick={() => chargeTransaction(transaction)}
    />
  );
};

export default ItemCheckoutButton;
